const COMPONENT_NAME = "AccordionSet";
export {
  COMPONENT_NAME
};
